<h1 class="p-4 text-2xl font-semibold m-2 sticky top-[80px] bg-slate-100 z-10">Available Claim-It Referrals</h1>
<div class="px-4 relative">
  <div class="table-wrapper relative">
    <table class="flex-1 w-full" cdk-table (contentChanged)="finishedLoading()" [dataSource]="dataSource">
      <thead>
        <!-- Add Date Column -->
        <ng-container cdkColumnDef="addDate">
          <th cdk-header-cell *cdkHeaderCellDef (click)="onSortClick('addDate')" class="py-2 px-4 cursor-pointer font-semibold whitespace-nowrap">
            Delivered
            <span *ngIf="sortKey === 'addDate'">
              {{ sortDirection === "asc" ? "↑" : sortDirection === "desc" ? "↓" : "" }}
            </span>
          </th>
          <td cdk-cell *cdkCellDef="let element" class="py-2 px-4">
            <div [ngClass]="UtilityService.timeAgo(element.addDate) == 'New' ? 'inline-block items-center rounded-full px-4 py-1 my-1 text-xs font-medium ring-inset bg-green-500 text-white' : ''">
              {{ UtilityService.timeAgo(element.addDate) }}
            </div>
            <div>{{ element.addDate | date: "short" }}</div>
          </td>
        </ng-container>

        <!-- Phone Column -->
        <ng-container cdkColumnDef="phone">
          <th cdk-header-cell *cdkHeaderCellDef class="py-2 px-4 w-24 font-semibold whitespace-nowrap"></th>
          <td cdk-cell *cdkCellDef class="p-4 min-w-5 whitespace-nowrap">
            <fa-icon [icon]="faPhoneVolume" class="pr-3" size="lg"></fa-icon><fa-icon [icon]="faCircleStar" class="pr-3" size="lg"></fa-icon>
          </td>
        </ng-container>

        <!-- Category Column -->
        <ng-container cdkColumnDef="category">
          <th cdk-header-cell *cdkHeaderCellDef (click)="onSortClick('category')" class="py-2 px-4 cursor-pointer font-semibold whitespace-nowrap">
            Category
            <span *ngIf="sortKey === 'category'">
              {{ sortDirection === "asc" ? "↑" : sortDirection === "desc" ? "↓" : "" }}
            </span>
          </th>
          <td cdk-cell *cdkCellDef="let element" class="py-2 px-4">{{ element.category }}</td>
        </ng-container>

        <!-- Policy Type Column -->
        <ng-container cdkColumnDef="businessLines">
          <th cdk-header-cell *cdkHeaderCellDef class="py-2 px-4 font-semibold whitespace-nowrap" colspan="2">Policy Type</th>
          <td cdk-cell *cdkCellDef="let element" class="py-2 px-4 min-w-80" colspan="2">{{ element.businessLines.join(", ") }}</td>
        </ng-container>

        <!-- Industry Column -->
        <ng-container cdkColumnDef="industry">
          <th cdk-header-cell *cdkHeaderCellDef (click)="onSortClick('industry')" class="py-2 px-4 cursor-pointer font-semibold whitespace-nowrap" colspan="2">
            Industry (NAICS)
            <span *ngIf="sortKey === 'industry'">
              {{ sortDirection === "asc" ? "↑" : sortDirection === "desc" ? "↓" : "" }}
            </span>
          </th>
          <td cdk-cell *cdkCellDef="let element" colspan="2" class="py-2 px-4">{{ element.industryDescription == null ? "" : element.industryDescription + " (" + element.industryCode + ")" }}</td>
        </ng-container>

        <!-- # Employees Column -->
        <ng-container cdkColumnDef="noOfEmployees">
          <th cdk-header-cell *cdkHeaderCellDef (click)="onSortClick('noOfEmployees')" class="py-2 px-4 cursor-pointer font-semibold whitespace-nowrap">
            # Employees
            <span *ngIf="sortKey === 'noOfEmployees'">
              {{ sortDirection === "asc" ? "↑" : sortDirection === "desc" ? "↓" : "" }}
            </span>
          </th>
          <td cdk-cell *cdkCellDef="let element" class="py-2 px-4">{{ element.noOfEmployees }}</td>
        </ng-container>

        <!-- Years in Business Column -->
        <ng-container cdkColumnDef="yearsInBusiness">
          <th cdk-header-cell *cdkHeaderCellDef (click)="onSortClick('yearsInBusiness')" class="py-2 px-4 cursor-pointer font-semibold whitespace-nowrap">
            Years in Business
            <span *ngIf="sortKey === 'yearsInBusiness'">
              {{ sortDirection === "asc" ? "↑" : sortDirection === "desc" ? "↓" : "" }}
            </span>
          </th>
          <td cdk-cell *cdkCellDef="let element" class="py-2 px-4">{{ element.yearsInBusiness }}</td>
        </ng-container>

        <!-- Estimated Premium Column -->
        <ng-container cdkColumnDef="estimatedPremium">
          <th cdk-header-cell *cdkHeaderCellDef (click)="onSortClick('estimatedPremium')" class="py-2 px-4 cursor-pointer font-semibold whitespace-nowrap">
            Est. Premium
            <span *ngIf="sortKey === 'estimatedPremium'">
              {{ sortDirection === "asc" ? "↑" : sortDirection === "desc" ? "↓" : "" }}
            </span>
          </th>
          <td cdk-cell *cdkCellDef="let element" class="py-2 px-4">{{ element.estimatedPremium }}</td>
        </ng-container>

        <!-- Location Column -->
        <ng-container cdkColumnDef="city">
          <th cdk-header-cell *cdkHeaderCellDef (click)="onSortClick('city')" class="py-2 px-4 cursor-pointer font-semibold whitespace-nowrap">
            Location
            <span *ngIf="sortKey === 'city'">
              {{ sortDirection === "asc" ? "↑" : sortDirection === "desc" ? "↓" : "" }}
            </span>
          </th>
          <td cdk-cell *cdkCellDef="let element" class="py-2 px-4">{{ element.city + ", " + element.state }}</td>
        </ng-container>

        <!-- Notes Column -->
        <ng-container cdkColumnDef="notes">
          <th cdk-header-cell *cdkHeaderCellDef class="py-2 px-4 font-semibold whitespace-nowrap" [ngClass]="!authGuard.isCarrier() ? 'w-72' : ''">Notes</th>
          <td cdk-cell *cdkCellDef class="py-2 px-4 min-w-72">
            <fa-icon [icon]="faMessageLines" class="pr-2" size="lg"></fa-icon>
            <fa-icon [icon]="faCircleEllipsis" class="pr-2" size="lg"></fa-icon>
            <button *ngIf="!authGuard.isCarrier()" class="bg-rose-800 hover:bg-rose-700 text-white font-bold py-2 px-4 rounded-full">
              <fa-icon [icon]="faPhone" class="pr-2"></fa-icon>
              Talk now - $30
            </button>
          </td>
        </ng-container>
      </thead>
      <tbody>
        <tr cdk-header-row *cdkHeaderRowDef="columnsToDisplay" class="font-medium text-left text-slate-500 shadow"></tr>
        <tr cdk-row *cdkRowDef="let row; columns: columnsToDisplay" class="border-t hover:bg-slate-50 text-slate-600"></tr>
      </tbody>
    </table>
  </div>
  <div class="flex flex-row py-2 lg:pr-3 justify-end pb-5">
    <!-- Help text -->
    <div class="inline-flex mt-2 xs:mt-0 px-4 text-indigo-950">
      <span class="text-sm content-center mx-2 inline-block pr-2">
        Showing <span class="font-semibold text-a">{{ pageNumber * pageSize + 1 }}</span> to <span class="font-semibold">{{ (pageNumber + 1) * pageSize }}</span> of
        <span class="font-semibold">{{ totalEntries }}</span> Referrals
      </span>
      <div class="flex">
        <span class="underline hover:no-underline cursor-pointer" (click)="updatePage(-1)">Previous</span> <span class="px-2">|</span>
        <span class="underline hover:no-underline cursor-pointer" (click)="updatePage(1)">Next</span>
      </div>
    </div>
  </div>
</div>
<div class="w-full flex justify-center">
  <fa-icon *ngIf="isLoading" [icon]="faGear" animation="spin" class="p-4 text-slate-600" size="2xl"></fa-icon>
</div>
